import { StateCreator } from 'zustand';

export interface AppSlice {
  // Sidebar state
  isSidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;

  // Mobile off-canvas sidebar (drawer) — independent of the desktop collapse state
  isMobileSidebarOpen: boolean;
  toggleMobileSidebar: () => void;
  setMobileSidebarOpen: (open: boolean) => void;

  // Admin-only "Show QIDs" overlay: reveals the Roger QID on visit-form fields.
  // Deliberately NOT persisted — resets to off on reload.
  showQuestionIds: boolean;
  toggleShowQuestionIds: () => void;
  setShowQuestionIds: (show: boolean) => void;
}

export const appSlice: StateCreator<AppSlice> = set => ({
  isSidebarCollapsed: false,

  toggleSidebar: () => {
    set(state => ({ isSidebarCollapsed: !state.isSidebarCollapsed }));
  },

  setSidebarCollapsed: (collapsed: boolean) => {
    set({ isSidebarCollapsed: collapsed });
  },

  isMobileSidebarOpen: false,

  toggleMobileSidebar: () => {
    set(state => ({ isMobileSidebarOpen: !state.isMobileSidebarOpen }));
  },

  setMobileSidebarOpen: (open: boolean) => {
    set({ isMobileSidebarOpen: open });
  },

  showQuestionIds: false,

  toggleShowQuestionIds: () => {
    set(state => ({ showQuestionIds: !state.showQuestionIds }));
  },

  setShowQuestionIds: (show: boolean) => {
    set({ showQuestionIds: show });
  },
});
